import PersonIcon from '@mui/icons-material/Person';
import UserManagement from './components/UserManagement';

export default {
    icon:  PersonIcon,
    recordRepresentation: 'reference',
    list: UserManagement
}